import React from 'react';
import { Helmet } from 'react-helmet-async';

const SearchSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Search Airport Parking Deals | Airport Parking Deals",
    "description": "Search and compare airport parking deals across all major airports. Find the best prices for Park & Ride, Meet & Greet, and Onsite parking.",
    "url": "https://airportparkingdeals.co.uk/search",
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://airportparkingdeals.co.uk"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Search Parking",
          "item": "https://airportparkingdeals.co.uk/search"
        }
      ]
    },
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://airportparkingdeals.co.uk/search?airport={airport_query}&departure={departure_date}&arrival={arrival_date}"
      },
      "query-input": "required name=airport_query"
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default SearchSchema;

